









































import Vue from 'vue';
import { mapGetters } from 'vuex';

const templateOptions = [
  { value: 'BASIC', label: 'B2C High Volume', description: 'Made for SaaS products with ARPU under $50 per month.' },
  { value: 'B2B', label: 'B2B Retention', description: 'Built for higher touch customer relationships.' },
  /* { value: 'MERGEFIELDS', label: 'Merge Fields', description: 'Give templates a personal touch by embedding customer information.' }, */
];

export default Vue.extend({
  name: 'TemplatePicker',
  props: {
    selectedTemplate: {
      required: false,
      type: String,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['currentSegment', 'primaryBlueprint']),
    allTemplateOptions() {
      const optionGroups = [];
      const segmentOptions = Object.keys(this.$store.state.segments || {})
        .reduce((acc: any, segmentId: string) => {
          const segment = this.$store.state.segments[segmentId];
          if (segment.name && !segment.deleted) {
            acc.push({
              value: `segment-${segment._id}`,
              segmentId: segment._id,
              label: segment.name,
              description: `Copy steps and offers from segmented flow`,
            });
          }
          return acc;
        }, [])
        .filter((d: any) => !(this.currentSegment && d.segmentId === this.currentSegment._id));
      let primaryOptions: any[] = [];
      if (this.currentSegment && this.primaryBlueprint) {
        primaryOptions = [{ value: 'primary', label: 'Your Primary Flow', description: 'Copy steps and offers from your primary cancel flow.' }];
      }
      optionGroups.push({
        key: 'default',
        label: 'Default Templates',
        options: templateOptions,
      });
      if (primaryOptions.length) {
        optionGroups.push({
          key: 'primary',
          label: 'Your Primary Flow',
          options: primaryOptions,
        });
      }
      if (segmentOptions.length) {
        optionGroups.push({
          key: 'segment-options',
          label: 'Your Custom Segments',
          options: segmentOptions,
        });
      }
      return optionGroups;
    },
  },
});
